import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ReduceToClearAction, ReduceToClearViewAction } from './reduce-to-clear.actions';
import {
  ReduceToClearListContent,
  ReduceToClearSearchCriteria,
  reduceToClearStatusList
} from '../../model/reduce-to-clear.model';

export interface ReduceToClearState extends EntityState<ReduceToClearListContent> {
  isLoading: boolean;
  selected: any[];
  criteriaObject: ReduceToClearSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewReduceToClear: any;
}

export const adapter: EntityAdapter<ReduceToClearListContent> = createEntityAdapter<ReduceToClearListContent>({
  selectId: (model: ReduceToClearListContent) => model.docNo
});

export const initialReduceToClearState: ReduceToClearState = adapter.getInitialState({
  isLoading: false,
  criteriaObject: {
    page: 0,
    size: 20,
    status: reduceToClearStatusList[0].value
  },
  selected: null,
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewReduceToClear: null
});

export const reduceToClearReducer = createReducer(
  initialReduceToClearState,
  on(ReduceToClearAction.responseList, (state, action): ReduceToClearState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  }),
  on(ReduceToClearViewAction.response, (state, action): ReduceToClearState => {
    return {
      ...state,
      viewReduceToClear: action.data
    };
  }),
  on(ReduceToClearViewAction.resetView, (state): ReduceToClearState => {
    return {
      ...state,
      viewReduceToClear: null
    };
  })
);
